'use strict';

module.exports = [function () {

        return {

            template: require('./mapDirective.html'),
            restrict: 'E',
            scope: {
                // show/hide google map controls
                useScrollWheel: "=",
                showMapTypeControl: "=",
                scaleControl: "=",
                showFullscreenControl: "=",
                showZoomControl: "=",
                showStreetViewControl: "=",

                // parameter
                mapId: "=",
                mapCenterLat: "=",
                mapCenterLng: "=",
                mapZoom: "=",
                showDrawing: '=',
                markers: "=",
                directions: "=",
                enableMarkerDraw: "=",
                enablePathDrawing: "=",
                shapes: "=",
                parentObjEditable: "=",
                mapDivStyle: "=",
                mapStyle: "=",

                showTrafficLayer: "=",
                showTransitLayer: "=",
                //publicInfoWindow: "=",
                
                markerShowDblclickOnInfowindow: "=",
                featureShowDblclickOnInfowindow: "=",

                objLayers: "=",
                /**
                 * activeEventId: se passato indica la riga da evidenziare come selezionato
                 */
                activeEventId: "=",

                // events
                markerChanged: '&onMarkerChanged',
                shapeChanged: '&onShapeChanged',
                directionsChanged: '&onDirectionsChanged',
                markerOpenEvent: '&onMarkerOpenEvent',      //callback richiamato al doppio click del marker
                mapBoundChangeEvent: '&onMapBoundChangeEvent',
                mapReady: '&onMapReady',
                markerClickEvent: '&onMarkerClickEvent', //callback richiamato al click di un marker
                featureOpenEvent: '&onFeatureOpenEvent', //callback richiamato al doppio click di una feature (punto su custom overlay)
                control: '='    // parent control
            },

            controller: require('./mapDirectiveCtrl.js'),

            link: function (scope) {

                scope.internalControl = scope.control || {};

                scope.internalControl.resetMap = function () {
                    var x = scope.myMap.getZoom();
                    var c = scope.myMap.getCenter();
                    google.maps.event.trigger(scope.myMap, 'resize');
                    scope.myMap.setZoom(x);
                    scope.myMap.setCenter(c);
                };

                scope.internalControl.selectMarker = function (eventId) {
     
                    var selectedMarker = undefined;
                    if (eventId) {                   
                        angular.forEach(scope.markers, function (marker) {
                            if (marker.idevent === eventId) {
                                selectedMarker = marker;
                            }
                        });
                    }
                    if (selectedMarker) {
                        var myLatlng = new google.maps.LatLng(selectedMarker.lat, selectedMarker.lon);
                        var image;

                        if (selectedMarker.icon && !selectedMarker.icon.isEmpty) {
                            image = {
                                url: "./assets/resources/ngDro-gMapModule/assets/statics/img/" + selectedMarker.icon + ".png",
                                scaledSize: new google.maps.Size(32, 32),
                            };
                        }
                        var marker = new google.maps.Marker({
                            idevent: selectedMarker.idevent,
                            position: myLatlng,
                            title: selectedMarker.description,
                            map: scope.myMap,
                            icon: image,
                            iconName: selectedMarker.icon,
                            draggable: scope.parentObjEditable,
                            type: google.maps.drawing.OverlayType.MARKER
                        });

                        scope.selectMarker(marker);
                    }
                };
            }
        };

    }];

/*
 * function resetMap(m) {
 x = m.getZoom();
 c = m.getCenter();
 google.maps.event.trigger(m, 'resize');
 m.setZoom(x);
 m.setCenter(c);
 }
 
 */


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/components/mapDirective/mapDirective.js
// module id = 326
// module chunks = 0